// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wFovKk5oPSojzghWEKOTT","button":"NnHlll4ZqIrfC2A_xuEJ_","icon1":"_1M1BQoCF5pQGA3BtyrYlhi","icon2":"oFMNVxsF7Q_W9fuJoUe3G","icon3":"_3S1lLzQDgm055Rejco8vQe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Main/styles.css
// module id = 2666
// module chunks = 0